'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function CheckmarkCircle(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-checkmark-circle ' + className,
      preserveAspectRatio: 'xMinYMin meet',
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { color: color, fillRule: 'evenodd', d: 'M16,8 C16,9.44086038 15.6397848,10.7741935 14.9193548,12 C14.1989249,13.2258065 13.2258065,14.1989249 12,14.9193548 C10.7741935,15.6397848 9.44086038,16 8,16 C6.55913962,16 5.22580645,15.6397848 4,14.9193548 C2.77419355,14.1989249 1.8010751,13.2258065 1.08064516,12 C0.360215218,10.7741935 0,9.44086038 0,8 C0,6.55913962 0.360215218,5.22580645 1.08064516,4 C1.8010751,2.77419355 2.77419355,1.8010751 4,1.08064516 C5.22580645,0.360215218 6.55913962,0 8,0 C9.44086038,0 10.7741935,0.360215218 12,1.08064516 C13.2258065,1.8010751 14.1989249,2.77419355 14.9193548,4 C15.6397848,5.22580645 16,6.55913962 16,8 Z M7.06451613,12.2258065 L13,6.29032258 C13.1075267,6.20430091 13.1612903,6.08602167 13.1612903,5.93548387 C13.1612903,5.78494607 13.1075267,5.66666683 13,5.58064516 L12.2903226,4.83870968 C12.1827959,4.73118296 12.0591396,4.67741935 11.9193548,4.67741935 C11.7795701,4.67741935 11.6559138,4.73118296 11.5483871,4.83870968 L6.70967742,9.67741935 L4.4516129,7.41935484 C4.34408619,7.31182812 4.22042994,7.25806452 4.08064516,7.25806452 C3.94086038,7.25806452 3.81720414,7.31182812 3.70967742,7.41935484 L3,8.16129032 C2.89247328,8.24731199 2.83870968,8.36559123 2.83870968,8.51612903 C2.83870968,8.66666683 2.89247328,8.78494607 3,8.87096774 L6.35483871,12.2258065 C6.44086038,12.3333332 6.55913962,12.3870968 6.70967742,12.3870968 C6.86021522,12.3870968 6.97849446,12.3333332 7.06451613,12.2258065 Z' })
  );
}

CheckmarkCircle.propTypes = {
  className: _react.PropTypes.string,
  width: _react.PropTypes.number,
  height: _react.PropTypes.number,
  color: _react.PropTypes.string
};

exports.default = CheckmarkCircle;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CheckmarkCircle/CheckmarkCircle.js
// module id = 186
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16